'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_T$package$EmptyTuple$() {
}
export { $c_T$package$EmptyTuple$ as $c_T$package$EmptyTuple$ };
$p = $c_T$package$EmptyTuple$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T$package$EmptyTuple$;
/** @constructor */
function $h_T$package$EmptyTuple$() {
}
export { $h_T$package$EmptyTuple$ as $h_T$package$EmptyTuple$ };
$h_T$package$EmptyTuple$.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return 924202651;
});
$p.n = (function() {
  return 0;
});
$p.o = (function() {
  return "EmptyTuple";
});
$p.g = (function(n) {
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
});
$p.b = (function() {
  return "()";
});
$p.y = (function(p) {
  return this;
});
var $d_T$package$EmptyTuple$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T$package$EmptyTuple$, "scala.Tuple$package$EmptyTuple$", ({
  s6: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_T$package$EmptyTuple$ as $d_T$package$EmptyTuple$ };
var $n_T$package$EmptyTuple$;
function $m_T$package$EmptyTuple$() {
  if ((!$n_T$package$EmptyTuple$)) {
    $n_T$package$EmptyTuple$ = new $c_T$package$EmptyTuple$();
  }
  return $n_T$package$EmptyTuple$;
}
export { $m_T$package$EmptyTuple$ as $m_T$package$EmptyTuple$ };
